/** Server-time based match phases. All values are epoch milliseconds in server time. */
export type MatchPhase = 'COUNTDOWN' | 'PLAYING' | 'ENDED';

export function getMatchPhase(nowMs: number, startsAtMs: number, endsAtMs: number): MatchPhase {
  if (nowMs < startsAtMs) return 'COUNTDOWN';
  if (nowMs < endsAtMs) return 'PLAYING';
  return 'ENDED';
}

/**
 * Whether a move received at `receivedAtMs` (server clock) may still be applied.
 * Moves before the start are never accepted; moves after ends_at are accepted only within
 * the configured network grace window.
 */
export function isWithinInputWindow(
  receivedAtMs: number,
  startsAtMs: number,
  endsAtMs: number,
  graceMs: number,
): boolean {
  return receivedAtMs >= startsAtMs && receivedAtMs <= endsAtMs + graceMs;
}

/**
 * Estimate (server time - client time) from one request round trip.
 * `serverTimeMs` was read by the server somewhere between `sentAtMs` and `receivedAtMs`.
 */
export function estimateClockOffset(sentAtMs: number, serverTimeMs: number, receivedAtMs: number): {
  offsetMs: number;
  rttMs: number;
} {
  const rttMs = Math.max(0, receivedAtMs - sentAtMs);
  return { offsetMs: serverTimeMs - (sentAtMs + rttMs / 2), rttMs };
}
